import PropTypes from 'prop-types';
// material
import { styled } from '@mui/material/styles';
import { Box, Typography, Grid, Container } from '@mui/material';

const MOCK_CAROUSELS = [
  {
    id: 1,
    image: '/static/1S.png',
    description: 'Restaurant Services'
  },
  {
    id: 2,
    image: '/static/2S.png',
    description: 'Repair and Mentainance'
  },
  {
    id: 3,
    image: '/static/3S.png',
    description: 'Parcel and Logistics'
  },
  {
    id: 4,
    image: '/static/4S.png',
    description: 'Other Services'
  }
];

const RootStyle = styled('div')(() => ({
  overflow: 'hidden',
  position: 'relative',
  marginTop:100,
  marginBottom: 100,
  height: 'auto'
}));

const CarouselImgStyle = styled('img')(({ theme }) => ({
  width: '100%',
  height: 'auto',
  margin: 'auto',
  objectFit: 'contain',
  transition: theme.transitions.create('all'),
  maxWidth: 500,
  [theme.breakpoints.down('sm')]: {
    maxWidth: 250
  }
}));

// ----------------------------------------------------------------------

CarouselItem.propTypes = {
  item: PropTypes.object
};

function CarouselItem({ item }) {
  const { image, title, description } = item;

  return (
    <Box
      sx={{
        mx: 1,
        borderRadius: 2,
        overflow: 'hidden',
        position: 'relative',
        width:{xs:'90%', md:'100%'},
        textAlign: 'center'
      }}
    >
      <CarouselImgStyle alt={title} src={image} />
      <Typography variant='h5'> {description}</Typography>
    </Box>
  );
}

export default function HomeServices() {
  return (
    <RootStyle>
      <Container>
        <Box sx={{ textAlign: 'center', mb:{xs:5, md:10} }}>
          <Typography variant='h4' sx={{ fontSize: { xs: '16px', md: '38px' } }}> Popular Gigs in your area </Typography>
        </Box>
        <Grid container spacing={1} justifyContent="center">
          {MOCK_CAROUSELS.map((item) => (
            <Grid item xs={6} sm={4} md={3} key={item.id}>
              <CarouselItem item={item} />
            </Grid>
          ))}
        </Grid>
      </Container>
    </RootStyle>
  );
}
